import { CSSProperties } from 'react';
import type { Theme } from '@mui/material/styles';
import { tbColors } from 'styles/colors';
import getMuiInputBase from './MuiInputBase';

const { paddingLeft } = getMuiInputBase().styleOverrides.input as CSSProperties;

const getMuiOutlinedInput = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      background: 'inherit',
      borderRadius: theme.shape.borderRadius,
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid '.concat(tbColors.all.ash[900]),
      },
      '& fieldset': {
        paddingLeft: 7,
        border: `1px solid ${tbColors.all.ash[900]}`,
        '& legend': {
          // update the font-size to be equal the label after transformation
          fontSize: '0.68875em',
          width: 0,
          '& span': {
            paddingLeft: 4,
            paddingRight: 4,
          },
        },
      },
      borderWidth: '1px',
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: tbColors.all.ash[900],
      },
      '& > input[readonly] ~ .MuiOutlinedInput-notchedOutline': {
        borderColor: tbColors.all.ash[900],
      },
      /*
       * textarea in multiline case creates second textarea element with
       * aria-hidden=true. This condition `:not([aria-hidden=true])`
       * mark only active (visible textarea)
       */
      '& > textarea[readonly]:not([aria-hidden=true]) ~ .MuiOutlinedInput-notchedOutline': {
        borderColor: tbColors.all.ash[900],
      },
    }),
    input: {
      paddingLeft,
      paddingBottom: 10,
      paddingTop: 10,
    },
    inputMultiline: {
      minHeight: 60,
      padding: '10px 12px',
    },
    multiline: {
      padding: 0,
    },
    inputSizeSmall: {
      paddingTop: 6,
      paddingBottom: 6,
    },
    inputAdornedStart: {
      paddingLeft: 0,
    },
    adornedEnd: {
      paddingRight: 0,
    },
  },
});
export default getMuiOutlinedInput;
